// extracted by mini-css-extract-plugin
export default {"checkbox":"CustomCheckbox_checkbox__aSdiE"};